import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { textTranslation, shouldTranslateTo } from "../utils/utils";

const Container = styled.div`
    /* margin-top: 35px; */
`;

const ImageCarousel = styled.div`
    /* display: none; */

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    

    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
`;

const Buttons = styled.div`
    width: 60vw;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    gap: 30px;
    margin: 50px 0 0 0;
`;

const CarouselButton = styled.button`
    background-color: transparent;
    border-radius: 50px;
    width: 50px;
    height: 50px;
    border: 1px solid #000;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
 
`;

const CarouselContent = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 35px;
    transition: transform 0.3s ease-in-out;
`;

const ItemContent = styled.div`
        width: 250px;
        min-width: 200px;
        height: 100%;
        background-color: #fff;
        padding: 21px 0 38px 0;
        gap: 24px;
        text-align: center;

        box-shadow: 0px 8px 16px 0px rgba(145, 158, 171, 0.16);
        border-radius: 4px;

        /* position: relative; */

        h5 {
            font-size: 16px;
            font-family: "Source Sans Pro", sans-serif !important;
            color: #154549;
        }
`;

const Image = styled.img`
    /* position: absolute; */
    margin-bottom: 24px;
    width: 100%;
    height: auto;
    /* max-width: 200px; */
    top: 0;
    left: 0;
`;


const ArrowIcon = styled.img`
    width: 12px;
    rotate: ${({ iconRotate }) => (iconRotate ? "180deg" : "0deg")};
`;

const PagesIndicator = styled.div`
    text-align: end;
    /* padding-right: 60px; */
    color: #000;

    h4 {
        font-size: 18px;
        font-family: "Open Sans", sans-serif !important;
    }
`;



const AwardsCarousel = ({ }) => {
    const [start, setStart] = useState(0);
    const [end, setEnd] = useState(4);
    const [interval, setInterval] = useState(4)

    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);

    const [pageText, setPageText] = React.useState([]);

    React.useEffect(() => {
        const language = shouldTranslateTo();
        const getPageText = (pageValue, languageValue) => {
            axios
                .get(`/api/page-text/${pageValue}/${languageValue}`)
                .then(response => {
                    let pageText = response.data.map(textItem => {
                        return textItem.text;
                    });

                    setPageText(pageText);
                })
                .catch(err => {
                    console.log("Error getting page text: ", err);
                });
        };

        getPageText("awards", language);

    }, []);

    const logosLink = [
        {
            image: "/images/logos/europeanCommission.svg",
            text: pageText[0],
        },
        {
            image: "/images/logos/europeanBank.svg",
            text: pageText[1],
        },
        {
            image: "/images/logos/ukri.svg",
            text: pageText[2],
        },
        {
            image: "/images/logos/untwo.svg",
            text: pageText[3],
        },
        {
            image: "/images/logos/worldTurism.svg",
            text: pageText[4],
        },
        {
            image: "/images/logos/again.svg",
            text: pageText[5],    
        },
    ];

    const handleNext = () => {
        if (currentPage + 1 <= totalPages) {
            setStart(start + interval);
            setEnd(end + interval);
            setCurrentPage(currentPage + 1);
        } else {
            setStart(0);
            setEnd(interval);
            setCurrentPage(1);
        }
    };

    const handlePrev = () => {
        if (currentPage - 1 > 0) {
            setStart(start - interval);
            setEnd(end - interval);
            setCurrentPage(currentPage - 1);
        } else {
            setStart(0);
            setEnd(interval);
            setCurrentPage(1);
        }
    };

    useEffect(() => {
        // console.log(logosLink);
        setTotalPages(Math.ceil(logosLink.length / interval));
        
        handleResize();
        window.addEventListener("resize", handleResize, false);
            
    }, [window.innerWidth]);

    const handleResize = () => {
        if (window.innerWidth > 1024) {
            setInterval(4);
            setEnd(4);
            setTotalPages(Math.ceil(logosLink.length / 4));
        }

        if (window.innerWidth <= 1024) {
            setInterval(3);
            setEnd(3);
            setTotalPages(Math.ceil(logosLink.length / 3));
        }

        if (window.innerWidth <= 700) {
            setInterval(2);
            setEnd(2);
            setTotalPages(Math.ceil(logosLink.length / 2));
        }

        if (window.innerWidth <= 460) {
            setInterval(1);
            setEnd(1);
            setTotalPages(Math.ceil(logosLink.length / 1));
        }
    }

    return (
        <Container>
            <ImageCarousel>
                <CarouselContent>
                    {logosLink.slice(start, end).map((current, index) => (
                        <ItemContent key={index}>
                            <Image
                                src={current.image}
                                alt={`img-${index}`}
                            />
                            <h5 dangerouslySetInnerHTML={{__html: current.text}}/>
                        </ItemContent>
                    ))}
                </CarouselContent>

                <Buttons>
                    <CarouselButton onClick={handlePrev}>
                        <ArrowIcon
                            src="/images/homepage/icons/arrow-line-bk.svg"
                            alt="arrow left"
                        />
                    </CarouselButton>
                    <PagesIndicator>
                        <h4><b>{currentPage}</b>/{totalPages}</h4>
                    </PagesIndicator>
                    <CarouselButton onClick={handleNext}>
                        <ArrowIcon
                            src="/images/homepage/icons/arrow-line-bk.svg"
                            alt="arrow right"
                            iconRotate
                        />
                    </CarouselButton>
                </Buttons>
            </ImageCarousel>
        </Container>
    );
};

export default AwardsCarousel;
